// extracted by mini-css-extract-plugin
module.exports = {"totalVotes":"styles_totalVotes__5sHjB","voters":"styles_voters__-A1IC","avgVotes":"styles_avgVotes__V0Ljw","minHeight":"styles_minHeight__3e4XT"};